module.exports = __webpack_public_path__ + "static/media/theft-protection.50ca4a09.png";